module.exports = __webpack_public_path__ + "images/edffbd4a68e8daf8cf90a5a3fec7663a.png";